var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgCross(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 19 19' }, props),
        React.createElement("path", { d: 'M.97.97a.75.75 0 01.976-.073L2.03.97l16 16a.75.75 0 01-.976 1.133l-.084-.073-16-16a.75.75 0 010-1.06z' }),
        React.createElement("path", { d: 'M16.97.97a.75.75 0 011.133.976l-.073.084-16 16a.75.75 0 01-1.133-.976l.073-.084 16-16z' })));
}
export default SvgCross;
//# sourceMappingURL=Cross.js.map